import { OrderStatus } from "orderme-api-integration-client";
import i18next from '../i18n/i18n';

export const getStatusTranslation = (orderStatus: OrderStatus) => {
    switch (orderStatus) {
        case OrderStatus.WaitingForPayment:
            return i18next.t('waitingForPayment', { ns: 'orderStatus' });
        case OrderStatus.Processing:
            return i18next.t('processing', { ns: 'orderStatus' });
        case OrderStatus.AcceptedBySalesPoint:
            return i18next.t('acceptedBySalesPoint', { ns: 'orderStatus' });
        case OrderStatus.ReadyToPickUpByCourier:
            return i18next.t('accepted', { ns: 'orderStatus' });
        case OrderStatus.Accepted:
            return i18next.t('accepted', { ns: 'orderStatus' });
        case OrderStatus.PickedUpByCourier:
            return i18next.t('pickedUpByCourier', { ns: 'orderStatus' });
        case OrderStatus.Ready:
            return i18next.t('ready', { ns: 'orderStatus' });
        case OrderStatus.Completed:
            return i18next.t('completed', { ns: 'orderStatus' });
        case OrderStatus.Cancelled:
            return i18next.t('cancelled', { ns: 'orderStatus' });
        default:
            return orderStatus;
    }
}

export const getStatusColor = (enumStatus: OrderStatus) => {
    switch (enumStatus) {
        case OrderStatus.WaitingForPayment:
        case OrderStatus.Cancelled:
            return "#a4a4a4";
        case OrderStatus.Processing:
            return "#de0403";
        case OrderStatus.AcceptedBySalesPoint:
            return "#ed7001";
        case OrderStatus.Accepted:
        case OrderStatus.ReadyToPickUpByCourier:
            return "#ffad01";
        case OrderStatus.PickedUpByCourier:
            return "#ffe500";
        case OrderStatus.Ready:
            return "#18df00";
        case OrderStatus.Completed:
            return "#0195d6";
    }
}

export const getProgress = (enumStatus: OrderStatus) => {
    switch (enumStatus) {
        case OrderStatus.WaitingForPayment:
        case OrderStatus.Cancelled:
            return 0;
        case OrderStatus.Processing:
            return 20;
        case OrderStatus.AcceptedBySalesPoint:
            return 35;
        case OrderStatus.Accepted:
        case OrderStatus.ReadyToPickUpByCourier:
            return 45;
        case OrderStatus.PickedUpByCourier:
            return 60;
        case OrderStatus.Ready:
            return 80;
        case OrderStatus.Completed:
            return 100;
    }
}